import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Menu } from '@pocketlaw/tetris';
import { useFuse } from 'shared/domains/common-utils/useFuse';
import { MenuFooter } from './MenuFooter';
export function ListMenu(props) {
    const { property, initialValue, onChange, onClear } = props;
    const { allowedValues, isMultiSelect } = property;
    const [query, setQuery] = useState('');
    const { result, search, active } = useFuse(allowedValues || [], {
        keys: ['text'],
    });
    const valuesToRender = active ? result : allowedValues;
    const showSearch = allowedValues && allowedValues.length > 6;
    const handleSearch = (value) => {
        setQuery(value);
        search(value);
    };
    const handleChange = (value) => {
        const newValue = isMultiSelect ? [value] : value;
        onChange(property, newValue);
    };
    const handleClear = () => {
        onClear(property);
    };
    if (!(allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.length)) {
        return null;
    }
    const selectedValue = allowedValues.find((value) => value.value === initialValue);
    const unselectedValues = valuesToRender === null || valuesToRender === void 0 ? void 0 : valuesToRender.filter((value) => value.value !== initialValue);
    return (<Menu.ItemNested maxWidth="unset" target={property.label}>
      {showSearch && (<Menu.HeaderSearch value={query} onChange={handleSearch} placeholder={t({
                message: 'Find value...',
                comment: 'Bulk action: Metadata - List menu - Find value placeholder',
            })}/>)}
      {selectedValue && (<Fragment>
          <Menu.Label>
            <Trans comment="Bulk action: Metadata - List menu - Selected values section title">Selected</Trans>
          </Menu.Label>
          <Menu.Item selected onClick={() => handleChange(selectedValue.value)} closeOnClick={!isMultiSelect}>
            {selectedValue.text}
          </Menu.Item>
        </Fragment>)}
      {unselectedValues && (unselectedValues === null || unselectedValues === void 0 ? void 0 : unselectedValues.length) > 0 && (<Menu.Label>
          <Trans comment="Bulk action: Metadata - List menu - Unselected values section title">Values</Trans>
        </Menu.Label>)}
      {unselectedValues &&
            unselectedValues.map((value) => (<Menu.Item key={`${value.value}-${value.text}`} onClick={() => handleChange(value.value)} closeOnClick={!isMultiSelect}>
            {value.text}
          </Menu.Item>))}
      <MenuFooter onClear={handleClear}/>
    </Menu.ItemNested>);
}
